import styled, { css } from 'styled-components';
import ReactSelect from 'react-select';

export default styled(ReactSelect)`
  & > div > div:first-child > div:first-child {
    min-height: 20px;
  }

  [class*='__menu'] {
    z-index: 20;
    background: ${({ theme }) => theme.colors.semantic.surface.card};
    border: 1px solid ${({ theme }) => theme.colors.semantic.border.default};
    box-shadow: ${({ theme }) => theme.colors.semantic.shadow.sm};
    border-radius: 8px;
  }

  [class*='__control'] {
    border-radius: 8px;
    min-height: 32px;
    border-color: ${({ theme }) => theme.colors.semantic.border.default};
    background: ${({ theme }) => theme.colors.semantic.surface.card};
    box-shadow: none;
  }

  [class*='__control--is-focused'] {
    background: ${({ theme }) => theme.colors.semantic.surface.card};
  }

  [class*='__placeholder'] {
    font-size: 14px;
    color: ${({ theme }) => theme.colors.semantic.text.secondary};
  }

  .select__control:hover {
    border-color: ${({ theme }) => theme.colors.primary500} !important;
  }

  [class*='__single-value'],
  [class*='__input-container'] {
    min-height: 0;
    color: ${({ theme }) => theme.colors.semantic.text.primary};
  }

  [class*='__value-container'] {
    color: ${({ theme }) => theme.colors.semantic.text.primary};
  }

  .select__input-container input {
    color: ${({ theme }) => theme.colors.semantic.text.primary} !important;
  }

  [class*='__input-container'] input {
    color: ${({ theme }) => theme.colors.semantic.text.primary} !important;
    -webkit-text-fill-color: ${({ theme }) =>
      theme.colors.semantic.text.primary} !important;
  }

  [class*='__control'] input,
  [class*='__value-container'] input {
    color: ${({ theme }) => theme.colors.semantic.text.primary} !important;
    -webkit-text-fill-color: ${({ theme }) =>
      theme.colors.semantic.text.primary} !important;
  }

  [class*='__indicator-separator'] {
    background-color: ${({ theme }) => theme.colors.semantic.border.subtle};
  }

  [class*='__dropdown-indicator'] {
    color: ${({ theme }) => theme.colors.semantic.text.secondary};
  }

  [class*='__option'] {
    color: ${({ theme }) => theme.colors.semantic.text.primary};
    background: ${({ theme }) => theme.colors.semantic.surface.card};
  }

  .select__option--is-disabled {
    color: ${({ theme }) => theme.colors.semantic.text.secondary};
    opacity: 0.5;
    cursor: not-allowed;
    pointer-events: auto;
  }

  .select__option--is-focused {
    background: ${({ theme }) => theme.colors.semantic.surface.muted};
  }

  .select__option--is-selected {
    background: ${({ theme }) => theme.colors.semantic.surface.selection};
  }

  .select__option:active,
  .select__option--is-focused:active,
  .select__option--is-selected {
    background: ${({ theme }) => theme.colors.semantic.surface.selection};
  }

  [class*='__control--is-disabled'] {
    background-color: ${({ theme }) => theme.colors.semantic.surface.muted};
    color: ${({ theme }) => theme.colors.semantic.text.secondary};
    cursor: not-allowed;
    opacity: 0.8;
  }

  [class*='__multi-value'] {
    background: ${({ theme }) => theme.colors.semantic.surface.muted};
    border-radius: 4px;
  }

  [class*='__multi-value__label'],
  [class*='__multi-value'] span {
    color: ${({ theme }) => theme.colors.semantic.text.secondary};
  }

  [class*='__multi-value__remove'] {
    color: ${({ theme }) => theme.colors.semantic.text.secondary};
    cursor: pointer;
  }

  [class*='__multi-value__remove']:hover {
    background: ${({ theme }) => theme.colors.semantic.surface.delete};
    color: ${({ theme }) => theme.colors.semantic.text.inverse};
  }

  [class*='__control--is-disabled'] [class*='__placeholder'],
  [class*='__control--is-disabled'] [class*='__input-container'] input {
    color: ${({ theme }) => theme.colors.semantic.text.secondary} !important;
  }

  width: ${props => (props.width ? props.width : '250px')};

  div {
    ${props =>
      props.invalid &&
      css`
        border-color: ${props.theme.colors.dangerPrimary} !important;
      `}
  }
`;
